import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { MaterialModel } from '@/libs/Api';
import { MaterialsDataService } from '@/libs/material/materials-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const scrapCausesStore = registerCrudStore<MaterialModel, MaterialModel>(
    BusinessModule.Material,
    new MaterialsDataService()
);